import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

import {
  Button,
  View,
} from 'components';

export default class Maintenance extends Component {

  /* Handlers */

  backbuttonHandler() {
    browserHistory.goBack();
  }

  /* Render */

  render() {
    return (
      <View
        backbutton={this.backbuttonHandler}
        title="errors.maintenance.title"
      >
        <div className="u-text-center">
          <div className="offset">
            <FormattedMessage id="errors.maintenance.description" />
          </div>
          <div className="offset offset--md">
            <Button
              className="button button-bg-yellow button-regular"
              onClick={this.backbuttonHandler}
              text="actions.back"
            />
          </div>
        </div>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./js/views/maintenance/index.jsx